import {
  ASSIGNMENT_PROGRESS_EMOJI,
  ASSIGNMENT_PROGRESS_LABELS,
  progressStatusModifier,
  type AssignmentProgressStatus,
} from "./assignmentProgressStatus";

export function ProgressStatusChip({
  status,
  className = "",
}: {
  status: AssignmentProgressStatus;
  className?: string;
}) {
  const mod = progressStatusModifier(status);
  return (
    <span className={`progress-chip progress-chip--${mod} ${className}`.trim()}>
      <span className="progress-chip-emoji" aria-hidden>
        {ASSIGNMENT_PROGRESS_EMOJI[status]}
      </span>
      <span className="progress-chip-label">{ASSIGNMENT_PROGRESS_LABELS[status]}</span>
    </span>
  );
}
